define('ordersDetailOrderProductOptionEditOptionView',[
  'module',
  'marionette',
  'underscore',    
  'template!ordersDetailOrderProductOptionEditOptionView'
], function (
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'option-view'    
  });
});
